import Link from 'next/link';

const footerSections = [
  {
    title: 'News',
    links: ['World', 'Politics', 'Business', 'Technology', 'Climate', 'Science'],
    hrefs: ['/world', '/world', '/world', '/world', '/world', '/world'],
  },
  {
    title: 'Features',
    links: ['Opinion', 'Analysis', 'In Depth', 'Correspondents', 'Investigations'],
    hrefs: ['/opinion', '/opinion', '/latest', '/world', '/world'],
  },
  {
    title: 'Sections',
    links: ['Sport', 'Culture', 'Travel', 'Health', 'Education'],
    hrefs: ['/world', '/world', '/world', '/world', '/world'],
  },
  {
    title: 'Video & Audio',
    links: ['Watch Live', 'Clips', 'Documentaries', 'Podcasts', 'In Pictures'],
    hrefs: ['/live', '/video', '/video', '/video', '/video'],
  },
  {
    title: 'Company',
    links: ['About', 'Contact', 'Careers', 'Advertise', 'Press', 'Editorial Standards'],
    hrefs: ['/about', '/about', '/about', '/about', '/about', '/about'],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#1A1A1A] text-[#CCCCCC] pt-12">
      <div className="max-w-[1400px] mx-auto px-5 pb-10 grid grid-cols-1 md:grid-cols-[220px_1fr] gap-12">
        {/* Brand */}
        <div>
          <Link href="/" className="flex items-end gap-0 mb-4">
            <span className="bg-[#C8102E] text-white font-['Playfair_Display',Georgia,serif] font-black text-[20px] px-3 py-1.5 leading-none">
              VERITAS
            </span>
            <span className="font-['IBM_Plex_Sans',system-ui,sans-serif] font-bold text-[9px] tracking-[0.18em] text-[#888] uppercase ml-2 pb-0.5">
              NEWS
            </span>
          </Link>
          <p className="font-['Source_Serif_4',Georgia,serif] italic text-[13px] text-[#888] leading-relaxed max-w-[180px]">
            Trusted journalism since 2008
          </p>
          <p className="font-['IBM_Plex_Sans',system-ui,sans-serif] text-[12px] text-[#555] mt-4 leading-relaxed max-w-[200px]">
            Reporting with independence, accuracy and accountability from every corner of the world.
          </p>
        </div>

        {/* Link columns */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6">
          {footerSections.map((section) => (
            <div key={section.title}>
              <h3 className="font-['IBM_Plex_Sans',system-ui,sans-serif] font-bold text-[11px] text-white tracking-[0.1em] uppercase mb-3">
                {section.title}
              </h3>
              <ul className="space-y-1.5">
                {section.links.map((link, i) => (
                  <li key={link}>
                    <Link
                      href={section.hrefs[i]}
                      className="font-['IBM_Plex_Sans',system-ui,sans-serif] text-[13px] text-[#888] hover:text-white transition-colors"
                    >
                      {link}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#333] py-4">
        <div className="max-w-[1400px] mx-auto px-5 flex justify-between items-center flex-wrap gap-3">
          <p className="font-['IBM_Plex_Sans',system-ui,sans-serif] text-[12px] text-[#555]">
            © 2025 Veritas News International. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            {['Privacy Policy', 'Terms', 'Accessibility', 'Cookies'].map((item, i) => (
              <span key={item} className="flex items-center gap-4">
                <Link
                  href="/about"
                  className="font-['IBM_Plex_Sans',system-ui,sans-serif] text-[12px] text-[#666] hover:text-[#CCCCCC] transition-colors"
                >
                  {item}
                </Link>
                {i < 3 && <span className="text-[#444] text-[11px]">|</span>}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
